import { createApp } from 'vue'
import App from './pages/App.vue'
// import EditOrder from './pages/EditOrder.vue'
import Login from './pages/Login.vue'
import AccountApp from './pages/AccountApp.vue'
import Rewards from './pages/Rewards.vue'
import Details from './pages/Details.vue'
import MyPlan from './pages/myPlan.vue'
import store from './store'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import './stylus/main.styl';

const vuetify = createVuetify({
  components,
  directives,
})

createApp(App).use(vuetify).use(store).mount('#order');
// createApp(EditOrder).use(vuetify).use(store).mount('#edit-order');
createApp(Login).use(vuetify).use(store).mount('#login');
createApp(AccountApp).use(vuetify).use(store).mount('#account');
createApp(AccountApp).use(vuetify).use(store).mount('#account-test');
createApp(Rewards).use(vuetify).use(store).mount('#rewards');
createApp(Details).use(vuetify).use(store).mount('#details');
createApp(MyPlan).use(vuetify).use(store).use(VCalendar, {}).mount('#my-plan');
